(function () {
  // Every candle on this site lives on its own alternate template
  // (/collections/all?view=<handle>), not on a /products/ page. Stock Shopify
  // components — product recommendations, search, related products — always
  // build /products/<handle> links, which 404 here. This routes them home.

  var VIEW_BASE = '/collections/all?view=';

  // Every candle goes to its own page. The Moments five stay waitlist-only —
  // their pages carry the waitlist form instead of an add-to-cart button — so
  // reaching them early is safe.
  var CANDLE_HANDLES = [
    'soulrise',
    'cloudbreak',
    'rooted-ember',
    'fallen-petal',
    'amber-dusk',
    'save-me-a-sweater',
    'save-me-some-candy',
    'sunday-morning',
    'meet-me-at-sunset',
    'kiss-me-in-the-rain',
    'dancing-barefoot',
    'flowers-for-no-reason',
    'a-moment-wrapped',
    'home-for-christmas',
    'home-for-christmas-tin',
    'under-the-mistletoe',
    'under-the-mistletoe-tin',
    'candlelight',
  ];

  // Some products were imported with a prefixed handle; strip it back off.
  var IMPORT_PREFIX = 'https-lindengreenstudio-ca-products-';

  function handleFromHref(href) {
    if (!href) return null;
    var path = href.split('?')[0].split('#')[0];
    var marker = path.indexOf('/products/');
    if (marker === -1) return null;
    var handle = path.slice(marker + 10).replace(/\/$/, '');
    if (!handle) return null;
    if (handle.indexOf(IMPORT_PREFIX) === 0) {
      handle = handle.slice(IMPORT_PREFIX.length);
    }
    return handle;
  }

  function destinationFor(handle) {
    if (CANDLE_HANDLES.indexOf(handle) !== -1) return VIEW_BASE + handle;
    return null;
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;

      // Opt-out for links that genuinely want the product page.
      if (link.hasAttribute('data-lgs-product-link')) return;

      var destination = destinationFor(handleFromHref(link.getAttribute('href')));
      if (!destination) return;

      event.preventDefault();
      window.location.href = destination;
    },
    true
  );

  // Candle care: the complete guide now lives at /pages/candle-care-safety.
  // Older care links (the ?view=candle-care page and the Journal's
  // #the-first-burn-changes-everything anchor) are pointed there, including
  // footer and Journal links that are rendered by snippets or Shogun.
  var CARE_URL = '/pages/candle-care-safety';

  function isOldCareLink(href) {
    if (!href) return false;
    return (
      href.indexOf('view=candle-care') !== -1 ||
      href.indexOf('#the-first-burn-changes-everything') !== -1
    );
  }

  function careDestination() {
    var preview = null;
    try {
      preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    } catch (_) {}
    return preview && /^\d+$/.test(preview)
      ? CARE_URL + '?preview_theme_id=' + preview
      : CARE_URL;
  }

  function updateCareLinks() {
    var destination = careDestination();
    document.querySelectorAll('a[href]').forEach(function (link) {
      if (isOldCareLink(link.getAttribute('href'))) {
        link.setAttribute('href', destination);
      }
    });
  }

  function startCareLinks() {
    updateCareLinks();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        updateCareLinks();
      }, 0);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCareLinks, { once: true });
  } else {
    startCareLinks();
  }
})();
